import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { jsx as _jsx } from "react/jsx-runtime";
const getUserPreferencesAvatarUploader = () => import( /* webpackChunkName: "avatar" */'./UserPreferencesAvatarUploader').then(module => module.default);
export default Loadable({
  loader: getUserPreferencesAvatarUploader,
  LoadingComponent: ({
    pastDelay
  }) => pastDelay ? /*#__PURE__*/_jsx(Modal, {
    children: /*#__PURE__*/_jsx(LoadingSpinner, {
      layout: "centered",
      minHeight: 200
    })
  }) : null
});